module.exports = __webpack_public_path__ + "img/six.1f24fc09.png";